export enum SortOrder {
  Desc = 'desc',
  Asc = 'asc',
}

export type SortingField = {
  id: string;
  order: SortOrder;
};

export enum modelType {
  User = 'USER',
  Enterprise = 'ENTERPRISE',
}
